/*jshint bitwise:false */
define('bindingHandlers/numberDisplay',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'lib/d3',
    'lib/dc',
    'util/dcChartUtils',
    'extensions/i18n/knockout.i18n'
], function (
    $,
    _,
    ko,
    d3,
    dc,
    chartUtils
) {
    'use strict';

    // ====================================================================
    // Constants & Variables
    // ====================================================================

    var DISPLAY_CLASS = "number-display";
    var NUM_DISPLAY_DOMDATA_KEY = "num-display-binding-data";

    // ====================================================================
    // Knockout Binding Handler
    // ====================================================================

    /**
     * Creates an instance of the DC.js number display widget using crossfilter groups.
     *
     * @param {Object} data.group - Each group is a subset of data for a
     *  crossfilter dimension. The number display widget will only react
     *  to changes in the provided group. See crossfilter documentation on for
     *  more information on groups:
     *  https://github.com/square/crossfilter/wiki/API-Reference#group-map-reduce
     *
     * @param {Object} data.accessor - The function used by the number display to
     *  get the value of a group object.
     *
     * @param {String} [format='n0'] - The desired format of the number
     *  display object. If not provided, format defaults to ko.i18n.format(value, 'n0').
     *
     * Example Usage:
     *
     * <div class="total" data-bind="numberDisplay: {
     *      data: {
     *          group: totalsGroup,
     *          accessor: valueAccessor
 *          },
     *      format: numberFormat
     *  }"></div>
     */
    ko.bindingHandlers.numberDisplay = {
        init: function (element, valueAccessor) {

            var $element     = $(element),
                bindingData  = ko.unwrap(valueAccessor());

            // Access elements of binding data
            var group       = ko.unwrap(bindingData.data.group);
            var accessor    = ko.unwrap(bindingData.data.accessor);
            var format      = bindingData.format    ? ko.unwrap(bindingData.format) : 'n0';

            if (!group) {
                throw new Error("Number display group parameter was undefined");
            }

            if (!accessor) {
                throw new Error("Number display value accessor parameter was undefined");
            }

            var displayId = _.uniqueId("_number_display_");

            var $displayNode = $("<div/>", {
                "class": DISPLAY_CLASS + displayId
            });

            $element.prepend($displayNode);

            // create number display
            var numDisplay = dc.numberDisplay($displayNode[0]);

            numDisplay
                .valueAccessor(accessor)
                .group(group);

            // format the display value using globalize number format
            numDisplay.formatNumber(function(datum) {
                return ko.i18n.format(datum, format);
            });

            numDisplay.render();

            // keep a ref of the number display instance for updating later
            chartUtils.setDomData(NUM_DISPLAY_DOMDATA_KEY, element, {
                "numberDisplay": numDisplay
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(window).off(DISPLAY_CLASS + displayId);
            });

        },

        update: function (element) {

            var numDisplay      = chartUtils.getDomDataValue(NUM_DISPLAY_DOMDATA_KEY, element, "numberDisplay");

            numDisplay.redraw();

        }
    };
});

